function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
      <circle cx="5" cy="5" r="5" fill="currentColor" />
    </svg>
  );
}

export default Icon;
